import { render, staticRenderFns } from "./MobileRecentNew.vue?vue&type=template&id=806d70ca&scoped=true&"
import script from "./MobileRecentNew.vue?vue&type=script&lang=js&"
export * from "./MobileRecentNew.vue?vue&type=script&lang=js&"
import style0 from "./MobileRecentNew.vue?vue&type=style&index=0&id=806d70ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806d70ca",
  null
  
)

export default component.exports